// extracted by mini-css-extract-plugin
export default {"sendMsg":"SendMsg_sendMsg__dubGh","tools":"SendMsg_tools__tgcv2","icon":"SendMsg_icon__eZFuJ","textArea":"SendMsg_textArea__fVs+c","sendBtn":"SendMsg_sendBtn__LfBEB"};